module.exports = "//static.hsappstatic.net/marketplace-assets-base/static-1.8278/img/business-types/retail.png"